(function () {
  function onClick(event) {
    var button = event.target.closest('.js-show-more-siblings');
    if (!button) return;

    var grid = button.closest('.sibling-swatches-grid');
    if (!grid) return;

    event.preventDefault();
    grid.classList.add('is-expanded');
    button.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', onClick);
})();
